<template>
    <div class="gray-back" style="padding:.2rem 0 8rem 0">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
            <van-divider>房间信息</van-divider>

            <van-cell-group v-for="(room,index) in row.room_list" v-if="room.edit==false" :key="index">

                <van-cell
                        input-align="right"
                        :title="room.name"
                        :border="false"
                >
                    <template #right-icon>
                        <span style="color: #FF4768">¥212</span> &nbsp;
                        <van-icon name="clear" @click="roomRemove(index)" style="line-height: inherit;" color="#999" />
                    </template>
                </van-cell>

                <div class="operate-desc-left">
                    <span v-for="member in room.member">{{member.name}}({{member.sex|sexName}}) {{member.type|typeName}}</span>
                </div>

            </van-cell-group>


            <van-cell-group  v-for="(room,index) in row.room_list" v-if="room.edit==true" :key="index">

                <van-field
                        readonly
                        clickable
                        right-icon="arrow"
                        input-align="right"
                        @click="showRoomTypePicker=true"
                        label="房型"
                        v-if="room.name"
                        :value="room.name+' '+room.price +'元 限住'+room.limit+'人'"
                />
                <van-field
                        readonly
                        clickable
                        v-else
                        right-icon="arrow"
                        input-align="right"
                        @click="showRoomTypePicker=true"
                        label="房型"
                        placeholder="请先选择房型？"
                />
                <van-popup v-model="showRoomTypePicker" position="bottom">
                    <van-picker :columns="row.room_type"
                                show-toolbar
                                value-key="name"
                                :default-index="0"
                                @cancel="showRoomTypePicker = false"
                                @confirm="onRoomTypeConfirm"
                    />
                </van-popup>


                <van-field
                        readonly
                        clickable
                        v-show="room.name"
                        right-icon="arrow"
                        input-align="right"
                        label="入住人"
                        placeholder="请选择人员"
                        @click="showMemberPicker = true"
                />
                <SaiRoomMemberPicker
                        :show="showMemberPicker"
                        :limit="memberLimit"
                        @onChange="onMemberChange"
                        @onClose="showMemberPicker=false"
                        :options="memberOptions"
                        :defaultValue="room.member"
                        @onConfirm="onMemberConfirm"
                ></SaiRoomMemberPicker>

                <div class="memberResultWrap" v-show="room.member.length>0">
                    <div class="memberLi" v-for="(user ,index) in room.member">
                        入住人{{index+1}}
                        <van-tag
                                :key="index"
                                round
                                color="#fff"
                                text-color="#666"
                                size="large"
                                closeable
                                type="primary"
                                @close="room.member.splice(index,1)"
                        > {{user.name}} {{user.sex|sexName}} {{user.type|typeName}}
                        </van-tag>
                    </div>
                </div>

            </van-cell-group>


            <div style="text-align: center">
                <van-button
                        v-if="(row.room_list.length==0|| !row.room_list[row.room_list.length-1].edit) && memberOptions.length>0"
                        style="width: 3rem;"
                        size="normal" round  native-type="button"   @click="roomAdd">新增房间</van-button>
                <van-button
                        v-if="row.room_list.length>0 && row.room_list[row.room_list.length-1].edit"
                        style="width: 3rem;"
                        size="normal" round  native-type="button"   @click="roomRemove(row.room_list.length-1)">删除</van-button>
                <van-button
                        v-if="row.room_list.length>0 && row.room_list[row.room_list.length-1].edit"
                        style="width: 3rem;"
                        size="normal" round  native-type="button"   @click="roomSave">保存</van-button>
            </div>


            <van-divider>确认信息</van-divider>

            <van-cell-group>

                <van-cell
                        input-align="right"
                        title="普通双人房"
                        value="1"
                />
                <van-cell
                        input-align="right"
                        title="普通单人房"
                        value="1"
                />
                <van-cell
                        input-align="right"
                        title="食宿费用"
                        value="1"
                />
                <van-cell
                        input-align="right"
                        title="人数"
                        value="1"
                />
                <van-field
                        input-align="right"
                        label="备注"
                        rows="2"
                        autosize
                        type="textarea"
                        placeholder="您的食宿特殊要求？"
                />


            </van-cell-group>


            <div class="savebtn">
                <van-button
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="保存中..." native-type="submit" @click="save">暂存信息</van-button>

                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">提交申请</van-button>
            </div>
        </van-form>



    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .memberResultWrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        padding: 0.2rem;
    }
    .memberResultWrap .memberLi{
        font-size: 14px;
        color: #666;
        height: 36px;
        line-height: 36px;
    }
    .memberResultWrap .memberLi .van-tag{
        width: auto !important;
    }

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,ActionSheet,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import SaiRoomMemberPicker from '@/components/picker/SaiRoomMemberPicker.vue';
    import FamliyPicker from '@/components/picker/FamliyPicker.vue';


    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyFormStep2',
        components: {
            [Field.name]: Field,
            PicUploader,
            FileUploader,
            SaiRoomMemberPicker,
        },
        data: function () {
            return {
                validator,
                saveLoading:false,
                showFamliyPicker:false,
                showSubjectPicker:false,
                showJiaolianPicker:false,
                showRoomTypePicker:false,
                showMemberPicker:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                subjectName:'',
                subjectArray:[],
                subjectOptions:[],
                subjectOptionsAll: [
                    {
                        name: '幼儿组',
                        children: [
                            {
                                name: '幼儿组',
                                children: [{ name: '舞蹈啦啦操',
                                    children:[
                                        {
                                            name: '花球规定动作',
                                        },
                                        {
                                            name: '222',
                                        }
                                    ] }, {
                                    name: '余杭区',
                                    children:[
                                        {
                                            name: '111',
                                        },
                                        {
                                            name: '222',
                                        }
                                    ]
                                }],
                            },
                            {
                                name: '温州',
                                children: [{ name: '鹿城区' }, { name: '瓯海区' }],
                            },
                        ],
                    },
                    {
                        name: '福建',
                        children: [
                            {
                                name: '福州',
                                children: [{ name: '鼓楼区' }, { name: '台江区' }],
                            },
                            {
                                name: '厦门',
                                children: [{ name: '思明区' }, { name: '海沧区' }],
                            },
                        ],
                    },
                ],
                row:{
                    room_list:[],
                    member_list:[],
                    room_type:[],
                },
                formData: {
                    id: 0,
                    saiqu_name:'xxxxx',
                    danwei:'xxxxx',
                    caipan:[],
                    music:[],
                    famliy:[],
                    tbydy:[],
                    jiaolian:[],
                    member:[],
                    areas:'',
                    province:'',
                    city:'',
                    county:'',
                    kaojitype:'考级中心',
                    changdipic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
                    zhizhaopic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
                },
            }
        },
        filters: {
            sexName(val){
                return val==1? '男' :'女';
            },
            typeName(val){
                switch (val){
                    case 1:
                        return '领队';
                        break;
                    case 2:
                        return '运动员';
                        break;
                    case 3:
                        return '教练员';
                        break;
                    case 4:
                        return '裁判员';
                        break;
                    default:
                        return '随行人员'
                }
            }
        },
        mounted() {
            let that = this;
            that.areaList = area;
          document.title="赛事申请"
            that.formData.id = this.$route.query.id;
            if(that.formData.id){
                this.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        computed:{
            memberOptions(){
                console.log('memberOptions');
                let option = this.row.member_list;
                let selectMember = [];
                this.row.room_list.map((room) =>{
                    if(room.edit==false){
                        selectMember = selectMember.concat(room.member);
                    }
                });
                let foption = option.filter((om) =>{
                    let nosearch = true;
                    selectMember.map((sm) =>{
                        if(sm.num == om.num){
                            //搜索存在num
                            nosearch = false;
                        }
                    });
                    return nosearch;
                })

                return foption;
            },
            memberLimit(){
                if(this.row.room_list.length==0){
                    return 0;
                }
                return this.row.room_list[this.row.room_list.length-1].limit;
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            onMemberConfirm(values){
                console.log('onMemberConfirm',values)
                this.showMemberPicker = false;
                this.row.room_list[this.row.room_list.length-1].member = [...values];
            },
            onMemberChange(values){
                console.log('onMemberChange',values)
                this.row.room_list[this.row.room_list.length-1].member = [...values];
            },
            roomAdd(){
                if(this.row.room_list.length >0 && this.row.room_list[this.row.room_list.length-1].edit){
                    return ;
                }
                this.row.room_list.push({
                    name:'',
                    room_id:'',
                    limit:0,
                    price:0,
                    member:[],
                    edit:true
                })
            },
            roomSave(){
                if(this.row.room_list.length ==0 || !this.row.room_list[this.row.room_list.length-1].edit){
                    return ;
                }
                if(!this.row.room_list[this.row.room_list.length-1].name){
                    Toast('请选择房型');
                    return;
                }
                if(this.row.room_list[this.row.room_list.length-1].member.length==0){
                    Toast('请选择人员');
                    return;
                }
                this.row.room_list[this.row.room_list.length-1].edit = false;
            },
            roomRemove(index){
                console.log('roomRemove');
                if(this.row.room_list.length ==0 ){
                    return ;
                }
                this.row.room_list.splice(index,1);
            },
            onRoomTypeConfirm(value, index){
                this.row.room_list[this.row.room_list.length-1].name = value.name;
                this.row.room_list[this.row.room_list.length-1].room_id = value.id;
                this.row.room_list[this.row.room_list.length-1].limit = value.limit;
                this.row.room_list[this.row.room_list.length-1].price = value.price;
                this.row.room_list[this.row.room_list.length-1].member = [];
                this.showRoomTypePicker = false;
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

                    if (that.formData.changdipic.length == 0) {
                        Toast('请上传场地照片');
                        return
                    }
                    if (that.formData.zhizhaopic.length == 0) {
                        Toast('请上传单位执照');
                        return
                    }
                    if (!this.formData.area) {
                        Toast('请选择地区');
                        return
                    }
                }
                that.saveLoading = true;

                if (that.submitType =='save') {
                    that.$api.post('/api/examecenter/save', that.formData, (res) => {
                        that.saveLoading = false;
                    }, (res) => {
                        Toast.fail(res.msg);
                        that.saveLoading = false;
                    })
                } else {
                    that.$api.post('/api/examecenter/apply', that.formData, (res) => {
                        that.saveLoading = false;
                    }, (res) => {
                        Toast.fail(res.msg);
                        that.saveLoading = false;
                    })
                }
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/sai/step4detail', {
                    id:that.formData.id
                }, (res) => {
                    that.row = res.data;
                }, (res) => {
                    Toast.fail(res.msg);
                })
            }

        }
    }
</script>



// WEBPACK FOOTER //
// SaiApplyFormStep4.vue?ee6c4922